import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { BasketIcon } from "@jti/brand-icons/basket";
import { BasketFillIcon } from "@jti/brand-icons/basket-fill";
import { useTranslations } from "@jti/ui";
import styles from "./CartIcon.module.scss";
export const CartIcon = ({ label, onClick, disabled, isOpen }) => {
    const { __ } = useTranslations();
    return (_jsxs("button", { "aria-label": __("cart.cart_mini.title"), type: "button", onClick: onClick, "data-testid": "cartIcon", className: classNames(styles.container, styles.icon, { [styles.disabled]: disabled }), children: [isOpen ? _jsx(BasketFillIcon, {}) : _jsx(BasketIcon, {}), label && _jsx("span", { className: styles.label, children: label })] }));
};
//# sourceMappingURL=CartIcon.js.map